module.exports = __webpack_public_path__ + "img/complete-01.85973689.png";